// VER-218: shared helpers for the Console admin UI (Step 11).

// Pull the human message out of the {success,data,error} envelope; fall back to a
// generic line so a network error never surfaces a blank toast.
export const errorMessage = (err) =>
  err?.response?.data?.error?.message || "Something went wrong. Please try again.";

// Role model — mirrors the backend src/constants/consoleRoles.ts. The API enforces
// RBAC; these are for labels and for hiding controls the actor can't use.
export const ROLES = {
  ACCOUNT_ADMIN: "account_admin",
  MEMBER: "member",
  SALES: "sales",
  FINANCE: "finance",
  TECH: "tech",
  INTERNAL_ADMIN: "internal_admin",
};

export const ROLE_LABELS = {
  account_admin: "Account Admin",
  member: "Member",
  sales: "Sales",
  finance: "Finance",
  tech: "Tech",
  internal_admin: "Internal Admin",
};

// External = client-side; Internal = VerifyU-side. This split drives the two user
// tables and the invite "user type" step. (DB stays one users table — role encodes
// the category; this is a presentation/filter concern only.)
export const EXTERNAL_ROLES = [ROLES.ACCOUNT_ADMIN, ROLES.MEMBER];
export const INTERNAL_ROLES = [ROLES.SALES, ROLES.FINANCE, ROLES.TECH, ROLES.INTERNAL_ADMIN];
export const ALL_ROLES = [...EXTERNAL_ROLES, ...INTERNAL_ROLES];
export const ADMIN_ROLES = [ROLES.ACCOUNT_ADMIN, ROLES.INTERNAL_ADMIN];

// Which side of the house a role belongs to.
export const roleCategory = (role) =>
  INTERNAL_ROLES.includes(role) ? "internal" : "external";

// Account category ("type"): external = client org, internal = VerifyU tenant.
export const ACCOUNT_TYPES = ["external", "internal"];
export const ACCOUNT_TYPE_LABELS = { external: "External (client)", internal: "Internal (VerifyU)" };

// The roles valid for an account of the given type.
export const rolesForAccountType = (type) => (type === "internal" ? INTERNAL_ROLES : EXTERNAL_ROLES);

// Which roles a given actor may assign/invite (mirrors invitableRolesFor on the API).
export function invitableRolesFor(role) {
  if (role === ROLES.INTERNAL_ADMIN) return ALL_ROLES;
  if (role === ROLES.ACCOUNT_ADMIN) return EXTERNAL_ROLES;
  return [];
}

export const roleLabel = (role) => ROLE_LABELS[role] || role;

// antd Tag colors for the status pill.
export const STATUS_COLORS = {
  active: "green",
  invited: "gold",
  removed: "red",
};
